module.exports = __webpack_public_path__ + "static/media/validation.fee3302f.svg";